import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './InvoiceSummaryPanel.module.scss';
export const GetInvoiceSummaryPanelTID = (parentTestId)=>getTestIds(parentTestId);
export const InvoiceSummaryPanel = (param)=>{
    let { vendorName, vendorLogoUrl, vendorAddress, clientName, invoiceNumber, issueDate, dueDate, amountDue, onViewInvoiceClick, testId } = param;
    const { InvoiceSummaryPanelTestIds } = GetInvoiceSummaryPanelTID(testId);
    const { t } = useLocaleKeys();
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": InvoiceSummaryPanelTestIds.Root(),
        className: styles.panel,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.vendorBlock,
                children: [
                    vendorLogoUrl != null && /*#__PURE__*/ _jsx("img", {
                        "data-testid": InvoiceSummaryPanelTestIds.VendorLogo(),
                        src: vendorLogoUrl,
                        alt: vendorName,
                        className: styles.vendorLogo
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h4",
                        testId: InvoiceSummaryPanelTestIds.VendorName(),
                        children: vendorName
                    }),
                    vendorAddress != null && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        testId: InvoiceSummaryPanelTestIds.VendorAddress(),
                        children: vendorAddress
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.detailsBlock,
                children: [
                    clientName != null && /*#__PURE__*/ _jsxs("div", {
                        className: styles.row,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                weight: "normal",
                                children: t.adHocInvoiceApproval.invoiceSummary.billedTo()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                testId: InvoiceSummaryPanelTestIds.ClientName(),
                                children: clientName
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.row,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                weight: "normal",
                                children: t.adHocInvoiceApproval.invoiceSummary.invoiceNumber()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                testId: InvoiceSummaryPanelTestIds.InvoiceNumber(),
                                children: invoiceNumber
                            })
                        ]
                    }),
                    issueDate != null && /*#__PURE__*/ _jsxs("div", {
                        className: styles.row,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                weight: "normal",
                                children: t.adHocInvoiceApproval.invoiceSummary.issueDate()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                testId: InvoiceSummaryPanelTestIds.IssueDate(),
                                children: issueDate
                            })
                        ]
                    }),
                    dueDate != null && /*#__PURE__*/ _jsxs("div", {
                        className: styles.row,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                weight: "normal",
                                children: t.adHocInvoiceApproval.invoiceSummary.dueDate()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                testId: InvoiceSummaryPanelTestIds.DueDate(),
                                children: dueDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.amountRow,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                children: t.adHocInvoiceApproval.invoiceSummary.amountDue()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h4",
                                testId: InvoiceSummaryPanelTestIds.AmountDue(),
                                children: amountDue.display()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                "data-testid": InvoiceSummaryPanelTestIds.ViewInvoiceLink(),
                className: styles.viewInvoiceLink,
                onClick: onViewInvoiceClick,
                children: t.adHocInvoiceApproval.invoiceSummary.viewInvoice()
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "normal",
                className: styles.poweredBy,
                testId: InvoiceSummaryPanelTestIds.PoweredByAnchor(),
                children: t.adHocInvoiceApproval.invoiceSummary.poweredByAnchor()
            })
        ]
    });
};
